import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DateRangePickerPopoverModule } from 'src/app/lib/date-range-picker-popover/date-range-picker-popover.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import {FilterPopupComponent} from "./filter-popup.component";
import {ButtonModule, ToggleModule} from "@xref/xref-lib";



@NgModule({
  declarations: [FilterPopupComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToggleModule,
    ButtonModule,
    PopoverModule.forRoot(),
  ],
  exports: [FilterPopupComponent]
})
export class FilterPopupModule { }
